
import React, { useState, useEffect, useRef } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { Table, Autocomplete, TableBody, Grid, FormControlLabel, Checkbox, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useAccesos } from '../contexts/AccesosContext';


function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}



function AddPreguntaEncuesta ({ handleNewPregunta, editPregunta, idEncuesta, cancelarEdicion, modoLectura }){
     // Estado para el título, descripción y selección del ComboBox
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [textoPregunta, setTextoPregunta] = useState('');
    const [tipoPreguntaSeleccionada, setTipoPreguntaSeleccionada] = useState(null);
    const [encuesta, setEncuesta] = useState([])
    const [esObligatoria, setEsObligatoria] = useState(false);
    const [requiereOpciones, setRequiereOpciones] = useState(false);
    const [ordenPregunta, setOrdenPregunta] = useState('');
    const [tipoPreguntas, setTipoPreguntas] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
    const [categorias, setCategorias] = useState([]);
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');
    const [opciones, setOpciones] = useState([]);
    const [nuevaOpcion, setNuevaOpcion] = useState('');
    const [nuevoOrden, setNuevoOrden] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [opcionToDelete, setOpcionToDelete] = useState(null);
    const [orden, setOrden] = useState('');
    const [preguntasEncuesta, setPreguntasEncuesta] = useState([]);

   
 
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
        // Obtener la fecha y hora actual
        function obtenerFechaISOsinZ() {
            const fecha = new Date();
            let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
            fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
            return fechaISO;
    }

     
        const fetchTiposPreguntas = async () => {
                try {
                    const response = await fetch(`${server}/CrmTipoPreguntums`);
                    const data = await response.json();
                    setTipoPreguntas(data.$values);
                } catch (error) {
                    console.error('Error al cargar los tipos de preguntas:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar los tipos de preguntas: ' + error,
                    });
                }
            };
             

        const fetchCategorias = async () => {
                try {
                    const response = await fetch(`${server}/CrmCategoriaPreguntums`);
                    const data = await response.json();
                    setCategorias(data.$values);
                } catch (error) {
                    console.error('Error al cargar las categorias:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar las categorias: ' + error,
                    });
                }
            };  

        const fetchOpcionesPregunta = async (idPregunta) => {
                try {
                    const response = await fetch(`${server}/CrmOpcionRespuestaEncuestums/poridPregunta/${idPregunta}`);
                    const data = await response.json();
                    // const opcionesTexto = data.$values.map((op) => op.textoOpcion); // Asegúrate que así se llama la propiedad
                    
                    const opcionesFormateadas = data.$values.map(op => ({
                        textoOpcion: op.textoOpcion,
                        idOpcionRespuesta: op.idOpcionRespuesta,
                        orden: op.orden
                    }));
                    setOpciones(opcionesFormateadas);
                } catch (error) {
                    console.error('Error al cargar las opciones:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar las opciones ' + error,
                    });
                }
            };
            
            
        const fetchPreguntasEncuesta = async () => {
            try {
                const response = await fetch(`${server}/CrmPreguntaEncuestums/poridEncuesta/${idEncuesta}`);
                const data = await response.json();
                setPreguntasEncuesta(data.$values);
            } catch (error) {
                console.error("Error al cargar preguntas de la encuesta:", error);
                Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron cargar las preguntas existentes.',
                });
            }
            };

            useEffect(() => {
  console.log("📌 Tipo pregunta seleccionada:", tipoPreguntaSeleccionada);
}, [tipoPreguntaSeleccionada]);

        useEffect(() => {
              fetchTiposPreguntas();
              fetchCategorias();
              fetchPreguntasEncuesta();
            }, [idEncuesta]);
        // Convertir a una cadena en formato ISO 8601
        const fechaFormateada = obtenerFechaISOsinZ();
        // Carga inicial de datos si estamos en modo edición
        useEffect(() => {
            // if (editPregunta && tipoPreguntas.length > 0) {
            if (editPregunta?.idPregunta) {

                setTextoPregunta(editPregunta.textoPregunta);
                
                const tipoPreguntaMatch = tipoPreguntas.find(e => e.id === editPregunta.idTipoPregunta);
                const categoriaMatch = categorias.find(c => c.id === editPregunta.idCategoria);
                
                // setTipoPreguntaSeleccionada(tipoPreguntaMatch || null);
                setTipoPreguntaSeleccionada({...tipoPreguntaMatch});
                setCategoriaSeleccionada(categoriaMatch || null);
                
                // setCampania(editObjetivo.idCampania);
                setEsObligatoria(editPregunta.esObligatoria || false);
                setOrdenPregunta(editPregunta.ordenPregunta);
                // setRequiereOpciones(editPregunta.requiereOpciones || false);
                setModificacion(2);
                setIngresadoPor(editPregunta.ingresadoPor);
                // loadPreguntaParaEditar(editPregunta.idPregunta, editPregunta.idEncuesta);
                // setIdEncuesta(editPregunta.idEncuesta);

                if (tipoPreguntaMatch?.requiereOpciones) {
                    fetchOpcionesPregunta(editPregunta.idPregunta);
                } else {
                    setOpciones([]); // Por si cambias de tipo y no necesita opciones
                }
            } else {
                setTextoPregunta('');
                setTipoPreguntaSeleccionada(null);

                
                setEncuesta('');
                setEsObligatoria(false);
                // setRequiereOpciones(false);
                setModificacion(1);
                setIngresadoPor('');
                setOpciones([]);
    
            }
        }, [editPregunta, tipoPreguntas, categorias]);


             useEffect(() => {
                if (esTipoDescripcion) {
                    setEsObligatoria(false);                    
                }
            }, [tipoPreguntaSeleccionada]);

        const mostrarOpciones = () => {
        return tipoPreguntaSeleccionada?.requiereOpciones === true;
        };

        const agregarOpcion = () => {
            const texto = nuevaOpcion.trim();
            const orden = parseInt(nuevoOrden, 10);
            // const numOrden = nuevaOrden.trim();

            if (!texto || isNaN(orden)){
                    Swal.fire({
                        icon: 'warning',
                        title: 'Faltan datos',
                        text: 'Debes ingresar texto y un orden válido.',
                    });
         return;
        }

        const ordenDuplicadoOpcion = opciones.some(op => op.orden === orden);
        const textoDuplicadoOpcion = opciones.some(opc => opc.textoOpcion.trim().toLowerCase() === texto.toLowerCase());

        if (ordenDuplicadoOpcion){
            Swal.fire({
                icon: 'warning',
                title: 'Orden duplicado',
                text:`Ya existe una opción con el orden ${orden}.`,
            });
            return;
        }

        if (textoDuplicadoOpcion) {
            Swal.fire({
                icon: 'info',
                title: 'Texto duplicado',
                text: 'Ya existe una opción con ese texto.',
            });
            return;
        }

        
        // const existe = opciones.some(op => op.textoOpcion === texto && op.orden === orden);
        // if (existe) {

        //             Swal.fire({
        //             icon: 'info',
        //             title: 'Duplicado',
        //             text: 'Esa opción ya fue agregada.',
        //         });
        //         return;
        //     }
            // const nuevaOrden = opciones.length + 1;

            setOpciones(prev => [...prev,{ textoOpcion: texto, orden }]);
           
            setNuevaOpcion('');
            setNuevoOrden('');
        
        };

        const handleOpenDialog = (opcion) => {
                setOpcionToDelete(opcion);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setOpcionToDelete(null);
            };

       
        
        // setOpciones(opciones.filter((_, i) => i !== index));
    
useEffect(() => {
  console.log("🔍 Opciones actuales:", opciones);
}, [opciones]);
        const handleDeleteOpcion= async () => {
           
                        if (!opcionToDelete) {
                            
                            return;
                            }
                            const username = ''+user.codigoUsuario+'/';

                             if (!opcionToDelete.idOpcionRespuesta) {
                                // Solo elimínala del estado local
                               
                                setOpciones(prev => prev.filter(op => op !== opcionToDelete));
                                handleCloseDialog();
                                return;
                            }

                            try {
                                  
                                const response = await fetch(`${server}/CrmOpcionRespuestaEncuestums/${opcionToDelete.idOpcionRespuesta}/${username}`,
                                     {
                                    method: 'DELETE'
                                });

                                if (response.ok) {

                                    // Actualiza la lista de opciones localmente
                                    setOpciones(opciones.filter(op => op.idOpcionRespuesta !== opcionToDelete.idOpcionRespuesta));

                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Éxito',
                                        text: 'Opción eliminado con éxito',
                                    });
                                } else {
                           
                
                                    const errorData = await response.json();
                                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                                    Swal.fire({
                                        icon: 'error',
                                        title: `Error ${response.status}`,
                                        text: errorMessage,
                                    });
                                }
                            } catch (error) {
                                console.error('Error al eliminar la opcion:', error);
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Error al eliminar la opcion: ' + error,
                                });            
                            } finally{
                                handleCloseDialog();
                            }
                        
        };

     // Manejo del formulario
        const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editPregunta? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear

            const endpoint = editPregunta ? `${server}/CrmPreguntaEncuestums/${editPregunta.idPregunta}` : `${server}/CrmPreguntaEncuestums`;
    
            const pregunta = { 
                idPregunta:editPregunta ? editPregunta.idPregunta:0,
                textoPregunta,
                idTipoPregunta: tipoPreguntaSeleccionada?.id || null,
                idEncuesta,
                // ...(resultado !== '' && { resultado }), 
                esObligatoria,
                idCategoria: categoriaSeleccionada?.id || null,
                ordenPregunta,
                // requiereOpciones,
                IngresadoPor: !editPregunta ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editPregunta ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                modificacion,
                fechaIngreso: fechaFormateada
            };

            Object.keys(pregunta).forEach(key => pregunta[key] === undefined && delete pregunta[key]);
            
            // console.log(endpoint)
    
            const ordenNumerico = parseInt(ordenPregunta, 10);
                const ordenDuplicado = preguntasEncuesta.some(p =>
                p.ordenPregunta === ordenNumerico && (!editPregunta || p.idPregunta !== editPregunta.idPregunta)
                );

                if (ordenDuplicado) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Orden duplicado',
                    text: `Ya existe otra pregunta con el orden ${ordenPregunta}.`,
                });
                return;
                }

            console.log("📤 Payload de pregunta:", pregunta);
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(pregunta),
                });
        console.log("🧠 Respuesta HTTP pregunta:", response);

                let nuevaPregunta = {};
                    if (method === 'POST') {
                    nuevaPregunta = await response.json();
                    }

        const idPreguntaFinal = method === 'POST' ? nuevaPregunta.idPregunta : editPregunta.idPregunta;
              
        if (response.ok) {
                    // const nuevaPregunta = await response.json();
                    //  const idPreguntaFinal = method === 'POST' ? nuevaPregunta.idPregunta : editPregunta.idPregunta;
                    console.log(nuevaPregunta)

                    console.log('mostrarOpciones:', mostrarOpciones());
                    console.log('tipoPreguntaSeleccionada:', tipoPreguntaSeleccionada);
                    console.log('opciones:', opciones);
                    
                if (mostrarOpciones() && opciones.length > 0) {
                    console.log('mostrarOpciones:', mostrarOpciones(), 'opciones.length:', opciones.length);
                    // const idPreguntaFinal = method === 'POST' ? nuevaPregunta.idPregunta : editPregunta.idPregunta;
                   console.log(' ID de la pregunta final para opciones:', idPreguntaFinal);
                    for (let opcion of opciones) {
                        // if(!opcion?.textoOpcion?.trim()) continue;
                        const texto = opcion?.textoOpcion?.trim();
                            if (!texto) continue;


                            const opcionData = {
                                // textoOpcion: opcion.textoOpcion.trim(),
                                textoOpcion : texto,
                                idPregunta: idPreguntaFinal,
                                ingresadoPor: user?.codigoUsuario,
                                fechaIngreso: fechaFormateada,
                                orden: opcion.orden,
                            };

                //             console.log('Guardando opciones:', opciones);
                //             console.log('Cada opción se envía como:', opcionData);

                //             await fetch(`${server}/CrmOpcionRespuestaEncuestums`, {
                //             method: 'POST',
                //             headers: { 'Content-Type': 'application/json' },
                //             body: JSON.stringify(opcionData) // pasar el objeto a almacenar
                //         });
                //     }
                // }

                if (!opcion.idOpcionRespuesta) {
                        // Opción nueva → crearla
                        await fetch(`${server}/CrmOpcionRespuestaEncuestums`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(opcionData),
                        });
                    } else {
                        // Opción existente → actualizar si cambia el texto (opcional)
                        const rest = await fetch(`${server}/CrmOpcionRespuestaEncuestums/${opcion.idOpcionRespuesta}`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                ...opcionData,
                                modificadoPor: user?.codigoUsuario,
                            }),
                        });
                        console.log("👉 PUT opción status:", rest.status);
                    }
                }
            }

                // Swal.fire({ icon: 'success', title: 'Guardado', timer: 1500, showConfirmButton: false });
                
                Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    }); 

                    setTextoPregunta('');
                    setTipoPreguntaSeleccionada(null);
                    setEsObligatoria(false);
                    setOrdenPregunta('');
                    setCategoriaSeleccionada(null);
                    setOpciones([]);

                    fetchPreguntasEncuesta();
                    handleNewPregunta();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar el la pregunta',
                    text: error.message || 'Ocurrió un error inesperado',
                });       } 
        };


const handleCancelarEdition = () => {
    setTextoPregunta('');
    setEsObligatoria(false);
    setOrdenPregunta('');
    setTipoPreguntaSeleccionada(null);
    setCategoriaSeleccionada(null);
    if (cancelarEdicion) cancelarEdicion();
    
}


 const esTipoDescripcion = tipoPreguntaSeleccionada?.tipoPregunta?.toLowerCase() === "instrucción o descripción";
    return (
        <>
        <h2>{editPregunta ? 'Editar Pregunta' : 'Agregar una Nueva Pregunta'}</h2>
        <br />
        <form onSubmit={handleSubmit} className="form-horizontal form-label-left" >
            <div className="item form-group">
            <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="tituloPregunta">
                    Texto de la pregunta: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="tituloPregunta"
                        required="required"
                        className="form-control"
                        value={textoPregunta}
                        onChange={(e) => setTextoPregunta(e.target.value)}
                        disabled={modoLectura}
                    />
                </div>
            </div>

              {/* ComboBox con Búsqueda (Autocomplete) */}
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="tipoObjetivo">
                        Tipo de Respuesta: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={tipoPreguntas}
                            getOptionLabel={(option) => option.tipoPregunta || ''}
                            value={tipoPreguntaSeleccionada}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setTipoPreguntaSeleccionada({
                                        ...newValue,
                                        requiereOpciones: newValue.requiereOpciones ?? false
                                    });
                                }
                            }}
                            
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            disabled={modoLectura}
                            // disableClearable
                        />
                    </div>
                    {/* <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="esObligatoria">
                        Requiere Opciones:
                    </label>
                   
                    <div className="col-md-4 col-sm-3 d-flex align-items-center">
                        <Checkbox
                        checked={requiereOpciones}
                        onChange={(e) => setRequiereOpciones(e.target.checked)}
                        />
                    </div> */}
            
                </div>
                 
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="categoria">
                        Categoria: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={categorias}
                            getOptionLabel={(option) => option.categoria || ''}
                            value={categoriaSeleccionada}
                            onChange={(event, newValue) => setCategoriaSeleccionada(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            // disableClearable
                            disabled={modoLectura}
                        />
                    </div>
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="ordenPregunta">
                        Orden Pregunta : <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <input
                            type="number"
                            id="ordenPregunta"
                            className="form-control"
                            value={ordenPregunta}
                            onChange={(e) => setOrdenPregunta(e.target.value)}
                            disabled={modoLectura}
                        />
                    </div>
                </div>

                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="esObligatoria">
                        Es Obligatoria:
                    </label>
                    {/* Checkbox en su columna alineado */}
                    <div className="col-md-4 col-sm-3 d-flex align-items-center">
                        <Checkbox
                        checked={esObligatoria}
                        onChange={(e) => setEsObligatoria(e.target.checked)}
                        disabled={esTipoDescripcion || modoLectura}
                        />
                        {esTipoDescripcion && (
                            <small className="text-muted ms-2">
                                Las preguntas de tipo "Instrucción o descripción" no pueden ser obligatorias.
                            </small>
                        )}
                    </div>
                </div>


                {/* <div className="item form-group">
                     <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="categorias">
                        Categoria: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={categorias}
                            getOptionLabel={(option) => option.categoria || ''}
                            value={categoriaSeleccionada}
                            onChange={(event, newValue) => setCategoriaSeleccionada(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.label === value.label}
                            disableClearable
                        />
                    </div>
                </div> */}

                {/* 🔽 Sección de opciones solo si aplica */}
                {mostrarOpciones() && (
                    <div className="item form-group">
                        <label className="col-form-label col-md-2 col-sm-3 label-align">
                            Opciones de Respuesta:
                        </label>
                        <div className="col-md-10 col-sm-9">
                            <div className="d-flex mb-2">
                                <input
                                    type="text"
                                    className="form-control me-2"
                                    placeholder="Escribe una opción"
                                    value={nuevaOpcion}
                                    onChange={(e) => setNuevaOpcion(e.target.value)}
                                    disabled={modoLectura}
                                />
                            
                                <input
                                    type="number"
                                    className="form-control me-2"
                                    placeholder="Orden de la opción"
                                    value={nuevoOrden}
                                    onChange={(e) => setNuevoOrden(e.target.value)}
                                    disabled={modoLectura}
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={agregarOpcion}
                                    disabled={modoLectura}
                                >
                                    Agregar
                                </button>
                            </div>

                            <ul className="list-group">
                                {opciones.map((opcion, index) => (
                                    <li className="list-group-item d-flex justify-content-between align-items-center" key={index}>
                                       {opcion.textoOpcion}
                                       
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger"
                                            onClick={() => handleOpenDialog(opcion)}
                                            disabled={modoLectura}
                                        >
                                            Eliminar
                                        </button>
                                     {opcion.orden}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={modoLectura || !tienePermiso('Crear Pregunta Encuesta')}>
                        {editPregunta ? 'Actualizar' : 'Guardar'}
                    </button>
                    {editPregunta && (
                <button type="button" className="btn btn-secondary" onClick={handleCancelarEdition}>
                    Cancelar
                </button>
            )}
                </div>
            </div>
        </form>

         <Dialog open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    ¿Estás seguro de que quieres eliminar esta opcion
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                <Button onClick={handleDeleteOpcion} color="primary" autoFocus>Eliminar</Button>
            </DialogActions>
         </Dialog>
        
    </>
    )

}

export default  AddPreguntaEncuesta;